// extracted by mini-css-extract-plugin
module.exports = {"root":"HomePacks_root__2j8cU"};